/**
 * Tema PG Soluções Inteligentes
 * Paleta azul corporativo — serviços de saneamento / SABESP
 * Se precisar ajustar as cores do logo, edite os valores de `brand`.
 */
import { extendTheme } from '@chakra-ui/react';
import baseTheme from './theme';

const pgColors = {
  colors: {
    brand: {
      50:  '#E6F0FB',
      100: '#BDD5F5',
      200: '#94BAEF',
      300: '#6B9FE9',
      400: '#4284E3',
      500: '#1264B2', // principal — azul PG
      600: '#0E529A',
      700: '#0A3F78',
      800: '#072D56',
      900: '#031A34',
    },
    brandScheme: {
      50:  '#E6F0FB',
      100: '#BDD5F5',
      200: '#94BAEF',
      300: '#6B9FE9',
      400: '#4284E3',
      500: '#1264B2',
      600: '#0E529A',
      700: '#0A3F78',
      800: '#072D56',
      900: '#031A34',
    },
    brandTabs: {
      50:  '#E6F0FB',
      100: '#BDD5F5',
      200: '#94BAEF',
      300: '#6B9FE9',
      400: '#4284E3',
      500: '#1264B2',
      600: '#0E529A',
      700: '#0A3F78',
      800: '#072D56',
      900: '#031A34',
    },
  },
};

export default extendTheme(baseTheme, pgColors);
